import React from 'react';
import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { BaseSelectDateInput, type BaseSelectDateInputProps } from '../date-input/BaseSelectDateInput';
import { useFormElement } from '../useFormElement';

export type ExpiryDateInputProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseSelectDateInputProps,
	'hasError' | 'name' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

/**
 *
 * @param {ExpiryDateInputProps} props - The component's props
 * @param {string} label - label to display
 * @param {string} children - use this in case label is not enough
 * @param {string} defaultChecked - initial checked state
 * @param {string} disabled - is the checkbox disabled
 * @param {boolean} isOnError - can be used to activate the on-error style
 * @param {function} onChange - on box click change callback
 */
export function ExpiryDateInput<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: ExpiryDateInputProps<T, FP>) {
	const {
		field,
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseSelectDateInput {...field} error={error} {...props} />;
}
